import { render, staticRenderFns } from "./BigScreen.vue?vue&type=template&id=8c807f9a&scoped=true"
import script from "./BigScreen.vue?vue&type=script&lang=js"
export * from "./BigScreen.vue?vue&type=script&lang=js"
import style0 from "./BigScreen.vue?vue&type=style&index=0&id=8c807f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c807f9a",
  null
  
)

export default component.exports